import Storage from '../Storage.js';

Storage.setConfig("couriers", {
  section: "main",
  config: {
    method: "couriers/",
    title: "Курьеры",
    objectName: "Курьер",
    adminGroup: true
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    name: {
      default: "",
      type: "text",
      title: "ФИО",
      width: "auto",
    },
    phone: {
      default: "",
      type: "text",
      title: "Телефон",
      width: false
    },
    mailing_states: {
      default: [],
      type: "courier-rewards",
      title: "Оплата",
      width: false
    },
  }
});


// WEBPACK FOOTER //
// ./src/config/couriers.js